export default [
  {
    path: '/produtos/:idproduto/:nomeproduto',
    name: 'DetalhesProduto',
    component: () => import('@/views/DetalhesProduto.vue'),
    meta: { public: true }
  },
  {
    path: '/categorias/:idcategoria/:desccategoria',
    name: 'ProdutosCategoria',
    component: () => import('@/views/ProdutosCategoria.vue'),
    meta: { public: true }
  },
  {
    path: '/buscar/:srcpesquisa',
    name: 'BuscarProdutos',
    component: () => import('@/views/BuscarProdutos.vue'),
    meta: { public: true }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('@/views/Checkout.vue'),
    meta: { requiresAuth: true }
  }
]
